// Reset de dados pedido pelo Launchpad (spec 062 US4). Quando este SPA está
// EMBUTIDO no painel Launchpad, aceita a mensagem `launchpad:reset` — e SÓ de uma
// origem confiável (o painel Launchpad ou um preview efêmero por PR) — para
// limpar storage + recarregar. Importar o módulo já liga o listener (efeito
// colateral); no-op fora de iframe.
//
// spec 070: previews migraram para 1-nível `<app>-pr<N>.eureca.dev`, então a
// allowlist deixou de ser o sufixo `.ef.eureca.dev` e passou a ser o host do
// painel + o label `-pr<N>` — NUNCA `.eureca.dev` cru (aceitaria canary/prod).
export function isTrustedLaunchpadOrigin(origin: string): boolean {
  try {
    const h = new URL(origin).hostname;
    return h === 'launchpad.eureca.dev' || /-pr\d+\.eureca\.dev$/.test(h);
  } catch {
    return false;
  }
}

function initLaunchpadEmbedReset(): void {
  if (typeof window === 'undefined' || window.top === window.self) return; // só embutido
  window.addEventListener('message', (event) => {
    if (event.data !== 'launchpad:reset' || !isTrustedLaunchpadOrigin(event.origin)) return;
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
      /* storage indisponível — segue o reload */
    }
    window.location.reload();
  });
}

initLaunchpadEmbedReset();
